import FeaturedStreamers from '../container/featuredStreamers';

export default function StreamingPane(props: any) {
  return <FeaturedStreamers {...props} type="popular-streamers" />;
}
